// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__sVymr","productName":"Table_productName__qA-EC"};